import { ENTRY_BASE_URL } from '@api/EntryApi';
import { axios } from '@lib/axios';

import { EntryAudioRecordStatus } from 'chaika-enums';

import {
    AudioRecordPreviewData,
    EntryAudioRecordCreateParams,
    EntryAudioRecordData,
    EntryAudioRecordListQuery,
    EntryAudioRecordUploadStateForm,
} from 'chaika-frontend-types/frontend-cms';

export class EntryAudioRecordsApi {
    public static async findRecords(params: EntryAudioRecordListQuery): Promise<EntryAudioRecordData[]> {
        const res = await axios.get(`${ENTRY_BASE_URL}/audio-record`, {
            params,
        });

        return res.data;
    }

    public static async createRecord(entryId: string, entryAudioRecord: EntryAudioRecordCreateParams): Promise<void> {
        await axios.post(`${ENTRY_BASE_URL}/${entryId}/audio-record`, { entryAudioRecord });
    }

    public static async retryRecord(entryId: string, audioRecordId: string): Promise<void> {
        await axios.post(`${ENTRY_BASE_URL}/${entryId}/audio-record/${audioRecordId}/retry`);
    }

    public static async syncUploadState(
        entryId: string,
        audioRecordId: string,
        uploadState: EntryAudioRecordUploadStateForm,
    ): Promise<void> {
        await axios.put(`${ENTRY_BASE_URL}/${entryId}/audio-record/${audioRecordId}/upload-state`, uploadState);
    }

    public static async updateRecordStatus(
        entryId: string,
        audioRecordId: string,
        status: EntryAudioRecordStatus,
    ): Promise<void> {
        await axios.put(`${ENTRY_BASE_URL}/${entryId}/audio-record/${audioRecordId}/status`, { status });
    }

    public static async deleteRecord(entryId: string, recordId: string): Promise<void> {
        await axios.delete(`${ENTRY_BASE_URL}/${entryId}/audio-record/${recordId}`);
    }

    public static async getTranscriptionPreview(
        entryId: string,
        audioRecordId: string,
    ): Promise<AudioRecordPreviewData> {
        const res = await axios.get(`${ENTRY_BASE_URL}/${entryId}/audio-record/${audioRecordId}/preview`, {
            skipForbiddenPopup: true,
        });
        return res.data;
    }

    public static async addTranscriptionToEntry(entryId: string, audioRecordId: string): Promise<void> {
        await axios.put(`${ENTRY_BASE_URL}/${entryId}/audio-record/${audioRecordId}/add`);
    }
}
